import React from 'react'
import {Modal} from './modal'
import {FiFileText, FiX} from "react-icons/fi";
import {useTranslation} from "react-i18next";
import {CODEMIRROR, CodeMirror} from "../form/field/codemirror";
import styled from 'styled-components'
import {IconClose} from "../icons";

const ModalWrapper = styled.div`
	width: 100%;
`

const ModalHeader = styled.div`
	display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

export const IconPlaceCircle = styled.span`
	display: flex;
	width: 40px;
	height: 40px;
	justify-content: center;
	align-items: center;
	/* gap: 8px; */
	aspect-ratio: 1/1;
	flex-grow: 0;
	flex-shrink: 0;

	border-radius: 999px;
	background: var(--it-bg-buttons);
  
  &[data-rectangle] {
    border-radius: unset;
  }
	
  &[data-button] {
    background-color: transparent;
    cursor: pointer;
    margin-left: auto;
    transition: all 0.4s;
    
    &:hover {
      background: var(--it-bg-buttons);
    }
  }
`

const ModalTitle = styled.div`
	color: var(--it-text-white);
	font-family: 'Druk Wide';
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 16.8px */
	letter-spacing: 0.42px;
	text-transform: uppercase;
`

const ModalBody = styled.div`
	width: 100%;
  margin-top: 24px;
  background-color: var(--it-bg-cards);

  display: flex;
  padding: 16px;
  flex-direction: column;
  //align-items: flex-end;
  gap: 12px;
  align-self: stretch;
`

export const ModalDescription = styled.div`
  color: var(--it-text-grey);

  /* Body 2 */
  font-family: "Basis Grotesque Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
  letter-spacing: 0.24px;
  
  p {
    //color: var(--it-text-white);
    font-size: 14px;
    margin-bottom: 16px;
  }
`

export const ModalInfo = ({
                                 title, description, icon,
                                 buttonTitle, buttonClassName,
                                 body,
                                 onCancel, onConfirm,
                                 ...rest
                             }) => {
    return (
        <Modal {...rest} onClose={onCancel}>
          <ModalWrapper>
            <ModalHeader>
              <IconPlaceCircle>
                {icon}
              </IconPlaceCircle>

              <ModalTitle>{title}</ModalTitle>

              <IconPlaceCircle data-button onClick={onCancel}>
                <IconClose size={20} />
              </IconPlaceCircle>
            </ModalHeader>

            <ModalBody>
              {description && <ModalDescription>{description}</ModalDescription>}

              {body}
            </ModalBody>
          </ModalWrapper>
        </Modal>
    )
}


export const ModalInfoLog = ({title, data, ...rest}) => {
    const {t} = useTranslation();

    return (
        <ModalInfo
            className={`w-full max-w-full lg:max-w-full`}
            icon={
                <span className="h-10 w-10 bg-red-100 text-white flex items-center justify-center rounded-full text-lg font-display font-bold">
                    <FiFileText size={18} className="stroke-current text-red-500"/>
                </span>
            }
            title={title || t('modal.infolog.title')}
            body={
                <div className={`text-sm text-grey-500 flex flex-col space-y-4`}>
                    <div className={`w-full `}>
                        <CodeMirror label={`Log`} defaultValue={data?.log} mode={CODEMIRROR.MODE.HTML}  />
                    </div>
                    <div className={`w-full `}>
                        <CodeMirror label={`Manifest`} defaultValue={JSON.stringify(data?.manifest, null, 4)} mode={CODEMIRROR.MODE.JS}  />
                    </div>
                </div>
            }
            {...rest}
        />
    )
}


